module.exports = __webpack_public_path__ + "static/media/about.9cd44041.svg";